import { useFetchCollectAreaQuery } from 'apis/collect_user/collectUserApi';
import { fetchWasteUnit } from 'apis/operator_site/siteApi';
import { SubstituteRegistInput } from 'components/organisms/SubstituteRegistInput';
import { PrimaryTemplate } from 'components/templates/PrimaryTemplate';
import { t } from 'i18next';
import { WasteUnitItem } from 'pages/AdminCustomizeItemsDetail';
import { useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Path } from 'routes';
import { ItemSize } from 'util/Enums';
import { handleError } from 'util/errorHandler';
import { useQuery } from 'util/queryParams';

const SubstituteRegistNew = () => {
  const history = useHistory();
  const { siteId, id } = useParams<{
    siteId: string;
    id: string;
  }>();
  const [wasteUnit, setWasteUnit] = useState<WasteUnitItem>();
  const prevUrl = useQuery().get('prevUrl') || Path.collects;

  const { data: areas } = useFetchCollectAreaQuery();

  useEffect(() => {
    fetchWasteUnit(Number(id), setWasteUnit).catch((e) => {
      handleError(e);
      history.replace(prevUrl);
    });
  }, []);

  const scalesType = useMemo(
    () => areas?.find((e) => e.siteId === siteId)?.scalesType,
    [areas, siteId]
  );

  return (
    <PrimaryTemplate
      prevFunction={() => {
        setWasteUnit(undefined);
        history.push(prevUrl);
      }}
      h1={t('substitute_regist_new.title')}
      className="substitute-regist-new"
    >
      <SubstituteRegistInput
        substituteRegistFromSiteId={siteId}
        emissionType={{
          id: wasteUnit?.id.toString() ?? '',
          name: wasteUnit?.name ?? '',
          other: false,
          imageUrl: wasteUnit?.imageUrl ?? '',
          materialName: wasteUnit?.materialName ?? '',
          size: ItemSize.LARGE,
          siteId: siteId,
          typeObject: 'wasteUnit',
          convertKg: wasteUnit ? Number(wasteUnit.convertKg) : null,
          quantity: wasteUnit ? Number(wasteUnit.quantity) : null,
          type: wasteUnit?.type,
          unit: wasteUnit?.unit ?? '',
          inputUnit: wasteUnit?.inputUnit ?? '',
        }}
        afterSubmit={() => {}}
        scalesType={scalesType}
      />
    </PrimaryTemplate>
  );
};

export default SubstituteRegistNew;
